/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse, HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QueryRequest } from '../../models/query-request';
import { StreamEvent } from '../../models/stream-event';

export interface StreamQueryApiV1ChatQueryStreamPost$Params {
      body: QueryRequest
}

export function streamQueryApiV1ChatQueryStreamPost(http: HttpClient, rootUrl: string, params: StreamQueryApiV1ChatQueryStreamPost$Params, context?: HttpContext): Observable<StreamEvent> {
  const rb = new RequestBuilder(rootUrl, streamQueryApiV1ChatQueryStreamPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return new Observable(observer => {
    let buffer = '';
    const subscription = http.post(rb.rootUrl + rb.operationPath, params.body, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'text/event-stream'
      },
      responseType: 'text',
      observe: 'events',
      reportProgress: true,
      context
    }).subscribe({
      next: (event: any) => {
        
        // Handle download progress - THIS IS WHERE THE STREAMING HAPPENS
        if (event.type === HttpEventType.DownloadProgress) {
          const fullText = event.partialText || '';
          const newChunk = fullText.substring(buffer.length);
          buffer = fullText;
          
          if (newChunk) {
            
            // Parse SSE format: "data: {...}\n\n"
            const lines = newChunk.split('\n');
            
            for (const line of lines) {
              if (line.startsWith('data: ')) {
                const data = line.substring(6).trim();
                
                // Check for end marker
                if (data === '[DONE]') {
                  console.log('Stream end marker received');
                  continue;
                }
                
                try {
                  const parsed = JSON.parse(data);
                  observer.next(parsed as StreamEvent);
                } catch (e) {
                  console.warn('Failed to parse SSE data:', data, e);
                }
              }
            }
          }
        }
        
        // Handle completion
        if (event.type === HttpEventType.Response) {
          console.log('Stream completed');
          observer.complete();
        }
      },
      error: (error) => observer.error(error),
      complete: () => observer.complete()
    });

    return () => subscription.unsubscribe();
  });
}

streamQueryApiV1ChatQueryStreamPost.PATH = '/api/v1/chat/query/stream';
